export default {
    0: {
        url: 'https://images.unsplash.com/photo-1488039505046-4b0d8dd5d416',
        title: 'Zero'
    },
    1: {
        url: 'https://images.unsplash.com/photo-1528752539854-fbf68419b935',
        title: 'One'
    },
    2: {
        url: 'https://images.unsplash.com/photo-1535827503360-d0ff681564f0',
        title: 'Two'
    },
    3: {
        url: 'https://images.unsplash.com/photo-1530051528223-01d6a86a154c',
        title: 'Three'
    },
    4: {
        url: 'https://images.unsplash.com/photo-1523286877159-d9636545890c',
        title: 'Four'
    },
    5: {
        url: 'https://images.unsplash.com/photo-1471094114392-6a87b3e78ee0',
        title: 'Five'
    },
    6: {
        url: 'https://images.unsplash.com/photo-1475720295950-2444738862a4',
        title: 'Six'
    },
    7: {
        url: 'https://images.unsplash.com/photo-1543893490-4deb3431e479',
        title: 'Seven'
    },
    8: {
        url: 'https://images.unsplash.com/photo-1533477618151-b517c954ebaa',
        title: 'Eight'
    },
    9: {
        url: 'https://images.unsplash.com/photo-1522447984233-657d56c465d8',
        title: 'Nine'
    },
    a: {
        url: 'https://images.unsplash.com/photo-1541600708691-a6e4123f8baa',
        title: 'Apple'
    },
    b: {
        url: 'https://images.unsplash.com/photo-1519916478825-b1d7aef08f54',
        title: 'Bowl'
    },
    c: {
        url: 'https://images.unsplash.com/photo-1546272989-40c92939c6c2',
        title: 'Chicken'
    },
    d: {
        url: 'https://images.unsplash.com/photo-1532028358058-44741b59154a',
        title: 'Doors'
    },
    e: {
        url: 'https://images.unsplash.com/photo-1473341304170-971dccb5ac1e',
        title: 'Electricty'
    },
    f: {
        url: 'https://images.unsplash.com/photo-1494778696781-8f23fd5553c4',
        title: 'Football'
    },
    g: {
        url: 'https://images.unsplash.com/photo-1541600708691-a6e4123f8baa',
        title: 'G'
    },
    h: {
        url: 'https://images.unsplash.com/photo-1541600708691-a6e4123f8baa',
        title: 'H'
    },
    i: {
        url: 'https://images.unsplash.com/photo-1541600708691-a6e4123f8baa',
        title: 'I'
    },
    j: {
        url: 'https://images.unsplash.com/photo-1541600708691-a6e4123f8baa',
        title: 'J'
    },
    k: {
        url: 'https://images.unsplash.com/photo-1541600708691-a6e4123f8baa',
        title: 'K'
    },
    l: {
        url: 'https://images.unsplash.com/photo-1541600708691-a6e4123f8baa',
        title: 'L'
    },
    m: {
        url: 'https://images.unsplash.com/photo-1522030299830-16b8d3d049fe',
        title: 'Moon'
    },
    n: {
        url: 'https://images.unsplash.com/photo-1541600708691-a6e4123f8baa',
        title: 'N'
    },
    o: {
        url: 'https://images.unsplash.com/photo-1541600708691-a6e4123f8baa',
        title: 'O'
    },
    p: {
        url: 'https://images.unsplash.com/photo-1541600708691-a6e4123f8baa',
        title: 'p'
    },
    q: {
        url: 'https://images.unsplash.com/photo-1541600708691-a6e4123f8baa',
        title: 'Q'
    },
    r: {
        url: 'https://images.unsplash.com/photo-1516849841032-87cbac4d88f7',
        title: 'Rocket'
    },
    s: {
        url: 'https://images.unsplash.com/photo-1541600708691-a6e4123f8baa',
        title: 'S'
    },
    t: {
        url: 'https://images.unsplash.com/photo-1541600708691-a6e4123f8baa',
        title: 'T'
    },
    u: {
        url: 'https://images.unsplash.com/photo-1541600708691-a6e4123f8baa',
        title: 'U'
    },
    v: {
        url: 'https://images.unsplash.com/photo-1541600708691-a6e4123f8baa',
        title: 'V'
    },
    w: {
        url: 'https://images.unsplash.com/photo-1541600708691-a6e4123f8baa',
        title: 'w'
    },
    x: {
        url: 'https://images.unsplash.com/photo-1541600708691-a6e4123f8baa',
        title: 'X'
    },
    y: {
        url: 'https://images.unsplash.com/photo-1541600708691-a6e4123f8baa',
        title: 'Y'
    },
    z: {
        url: 'https://images.unsplash.com/photo-1541600708691-a6e4123f8baa',
        title: 'Z'
    }
}